export default function Send() {
    return (
        <svg
            width="19"
            height="19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.038 1.038l-9.336 9.336M18.038 1.038l-5.94 16.975-3.396-7.639L1.063 6.98l16.975-5.941z"
                stroke="#BDBDBD"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
